import React, { Component } from "react";
import { render } from "react-dom";

import Router from "./components/Router";

import "./css/style.css";

render(<Router />, document.getElementById("main"));



// WEBPACK FOOTER //
// ./src/index.js